import ACField from './components/ACField.vue';

export default {
  components: { ACField },
  data() {
    return {
      pagePers: null,
      dialogPers: false,
      fields: [],
      key: 0,
      ndflData: {
        last_name: '',
        first_name: '',
        middle_name: '',
      },
      form: {
        loaded: false,
      },
      suggestions: [],
      suggestions_items: [],
      valid: false,
      rules: {
        required: v => (v !== null && v !== undefined && String(v).trim().length > 0) || 'Поле обязательно',
      },
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    user() {
      return this.$store.state.user;
    },
    requirePers() {
      return this.user
          && this.$store.state.settings.profile_pers === true
          && !this.$store.state.user.pers_at;
    },
    account() {
      return this.$store.state.user.account;
    },
    isDisabledForm() {
      return this.account && (this.account.status === 'approved' || this.account.status === 'new');
    },
  },
  methods: {
    handleInput(val, input) {
      console.log('asdfasdfdsf');
      this.$set(this.form, input, val);
    },
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/auth/confirm-pers', { profile_id: app.user.profile_id })
        .then(() => {
          app.user.pers_at = true;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone_mobile })
        .then((response) => {
          app.pagePers = response.data.pagePers;
        });
    },
    async LoadPassport() {
      const app = this;
      try {
        const fieldsData = await app.$store.getters.axl.post('taxes/api/forms/fields', { profile_id: app.user.profile_id });
        app.fields = fieldsData.data.fields;
        const profileTaxInfoResponse = await app.$store.getters.ax.post('taxes/api/forms/get', { profile_id: app.user.profile_id });
        const profileTaxInfo = profileTaxInfoResponse.data.form;

        if (profileTaxInfo) {
          app.ndflData = profileTaxInfo;
          delete app.ndflData.document1;
          delete app.ndflData.document2;

          app.form.comments = profileTaxInfo.comments;
        } else {
          app.ndflData.last_name = app.user.last_name;
          app.ndflData.first_name = app.user.first_name;
          app.ndflData.middle_name = app.user.middle_name;
        }

        const fieldsLength = app.fields.length;
        for (let i = 0; i < fieldsLength; i += 1) {
          this.$set(this.$data.form, app.fields[i].name, app.ndflData[app.fields[i].name]);
          if (app.fields[i].type === 'file') {
            this.$set(this.$data.form, app.fields[i].name, {
              filename: profileTaxInfo ? profileTaxInfo[`${app.fields[i].name}`] : '',
              base64: profileTaxInfo ? profileTaxInfo[`${app.fields[i].name}_file`] : '',
              name: '',
              url: '',
              id: null,
            });
          }
        }
        app.form.loaded = true;
      } catch (error) {
        this.$store.dispatch('HandleError', error);
      }
    },
    SetACField(e) {
      this.$set(this.$data.form, e.inputName, e.address);
      this.$set(this.$data.form, `${e.inputName}_data`, e.data);
    },
    LoadFromUser() {
      this.form.last_name = this.user.last_name;
      this.form.first_name = this.user.first_name;
      this.form.middle_name = this.user.middle_name;
    },
    PickDocument(name) {
      this.$refs[name][0].click();
    },
    OnDocument(e, name) {
      this.OnFilePicked(e, name);
    },
    OnFilePicked(e, name) {
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        app.form[name].filename = files[0].name;
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          app.form[name].base64 = fr.result;
          app.$forceUpdate();
        });
      }
    },
    /*
    async ResizeImg(img) {
      let file = '';
      try {
        const compressedFile = await imageCompression(img, this.compressOptions);
        file = compressedFile;
      } catch (error) {
        console.error(error);
      }
      return file;
    },
    */
    getRules(input) {
      const rules = [];
      const isRequired = !!input.required;
      if (isRequired && input.type !== 'file') {
        rules.push(this.rules.required);
      }
      if (input.type === 'file' && isRequired) {
        rules.push(v => !!v || 'Необходимо прикрепить файл');
      }
      if (input.name === 'inn') {
        rules.push(this.validateInnRule);
      }
      if (input.name === 'birthday_on') {
        rules.push(this.validateBirthdayRule);
      }
      return rules;
    },
    validateInnRule(v) {
      const digits = String(v || '').replace(/\D/g, '');
      if (digits.length === 0) return true;
      if (digits.length !== 12) return 'ИНН должен содержать 12 цифр';
      if (digits === '000000000000') return 'Введен неправильный номер ИНН';
      const d = digits.split('').map(Number);
      const num10 = (((7 * d[0]) + (2 * d[1]) + (4 * d[2]) + (10 * d[3]) + (3 * d[4])
        + (5 * d[5]) + (9 * d[6]) + (4 * d[7]) + (6 * d[8]) + (8 * d[9])) % 11) % 10;
      const num11 = (((3 * d[0]) + (7 * d[1]) + (2 * d[2]) + (4 * d[3]) + (10 * d[4])
        + (3 * d[5]) + (5 * d[6]) + (9 * d[7]) + (4 * d[8]) + (6 * d[9]) + (8 * d[10])) % 11) % 10;
      if (d[10] !== num10 || d[11] !== num11) return 'Введен невалидный номер ИНН';
      return true;
    },
    validateBirthdayRule(v) {
      const s = String(v || '');
      if (s.length === 0) return true;
      if (!/^\d{2}\.\d{2}\.\d{4}$/.test(s)) return 'Дата должна быть в формате дд.мм.гггг';
      const parts = s.split('.').map(Number);
      const day = parts[0];
      const month = parts[1];
      const year = parts[2];
      if (month < 1 || month > 12 || day < 1 || day > 31) return 'Некорректная дата';
      const today = new Date();
      let age = today.getFullYear() - year;
      const curMonth = today.getMonth() + 1;
      if (curMonth < month || (curMonth === month && today.getDate() < day)) {
        age -= 1;
      }
      if (age < 17 || age > 90) return 'Дата рождения не может быть меньше 17 лет и больше 90 лет';
      return true;
    },
    validateFile(input) {
      const f = this.form[input.name];
      if (!f) return `Необходимо прикрепить «${input.label}»`;
      const hasContent = f.filename && (f.base64 || f.url);
      if (!hasContent) return `Необходимо прикрепить «${input.label}»`;
      return true;
    },
    validateAll() {
      const errors = [];
      const vFormValid = this.$refs.form ? this.$refs.form.validate() : true;
      if (!vFormValid) errors.push('Заполните корректно все поля формы');

      for (let i = 0; i < this.fields.length; i += 1) {
        const input = this.fields[i];
        const isRequired = !!input.required;
        const value = this.form[input.name];

        if (isRequired) {
          if (input.type === 'file') {
            const r = this.validateFile(input);
            if (r !== true) errors.push(r);
          } else if (input.dadata) {
            if (value === null || value === undefined || String(value).trim().length === 0) {
              errors.push(`Поле «${input.label}» обязательно`);
            }
          } else if (value === null || value === undefined || String(value).trim().length === 0) {
            errors.push(`Поле «${input.label}» обязательно`);
          }
        }

        if (input.name === 'inn') {
          const r = this.validateInnRule(value);
          if (r !== true) errors.push(r);
        }
        if (input.name === 'birthday_on') {
          const r = this.validateBirthdayRule(value);
          if (r !== true) errors.push(r);
        }
      }
      return errors;
    },
    SavePassport() {
      const app = this;
      const errors = this.validateAll();
      if (errors.length > 0) {
        app.$store.dispatch('ShowError', errors[0]);
        return;
      }
      const data = {};
      data.profile_id = app.user.profile_id;
      data.data = app.form;

      app.$store.getters.axl.post('taxes/api/forms/save', data)
      // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$store.dispatch('GetProfile');
          this.LoadPassport();
          app.$store.dispatch('ShowInfo', 'Анкета сохранена!');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  async mounted() {
    await this.$store.dispatch('GetProfile');
    await this.LoadPassport();
    if (this.requirePers) {
      this.LoadPers();
    }
  },
};
